import { jsx as g } from "@emotion/react/jsx-runtime";
import e from "prop-types";
import { BREAKPOINTS as r } from "../../constants.mjs";
import { GRID_PADDING as t } from "./gridConstants.mjs";
import { css as a } from "@emotion/react";
const s = (o, m) => {
  const l = typeof m == "object" ? {
    small: !1,
    medium: !1,
    large: !1,
    ...m
  } : {
    small: m,
    medium: m,
    large: m
  };
  return [
    l.small && a`
                @media (max-width: ${r.MEDIUM}rem) {
                  margin-${o}: -${t.SMALL};
                }
            `,
    l.medium && a`
                @media (min-width: ${r.MEDIUM}rem) and (max-width: ${r.LARGE}rem) {
                  margin-${o}: -${t.MEDIUM};
                }
            `,
    l.large && a`
                @media (min-width: ${r.LARGE}rem) {
                  margin-${o}: -${t.LARGE};
                }
            `
  ];
}, c = "div", i = ({
  component: o,
  left: m,
  right: l,
  children: n,
  ...p
}) => {
  const f = o || c, d = [...s("left", m), ...s("right", l)];
  return /* @__PURE__ */ g(f, { ...p, css: d, children: n });
};
i.propTypes = {
  /** Component type used to render the bleeding */
  component: e.oneOfType([e.string, e.element]),
  /** Enable left side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  left: e.oneOfType([
    e.bool,
    e.shape({
      small: e.bool,
      medium: e.bool,
      large: e.bool
    })
  ]),
  /** Enable right side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  right: e.oneOfType([
    e.bool,
    e.shape({
      small: e.bool,
      medium: e.bool,
      large: e.bool
    })
  ])
};
const M = i;
export {
  M as default
};
